import React from 'react';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import InputNotation from './atom/InputNotation';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import InputField from './atom/InputField';
import {
  AggravatingInterface,
  DegradationInterface,
  fieldObservationProps,
  MeasureInterface,
  ShowDataCalculProps,
  showInspectionProps,
  TreatmentTypeInterface,
  TrueFalseInterface,
} from './Interface';
import RadioList from 'saur_ui_library/src/Molecules/RadioList/RadioList';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import Field from 'saur_ui_library/src/Molecules/Field/Field';
import { inputTextDate } from '../../utils/helpers/view/detailsHelper';
import ModernDatePicker from '../../components/common/component/ModernDatePicker';
import Switch from './atom/Switch';

export const Title = () => {
  const showTitle: any = [];
  [1, 2, 3, 4].forEach((number) => {
    return showTitle.push(
      <Container key={number} className='notation-title'>
        {/* Number title */}
        <Word
          variant='p'
          textStyle='normalBold'
          value={number.toString()}
          className='notation-title-word'
          automatedTestId={'notation-title-' + number}
        />
      </Container>,
    );
  });

  return showTitle;
};

export const dateFr = {
  // months list by order
  months: [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ],

  // week days by order
  weekDays: [
    {
      name: 'Dimanche', // used for accessibility
      short: 'Di', // displayed at the top of days' rows
      isWeekend: true, // is it a formal weekend or not?
    },
    {
      name: 'Lundi',
      short: 'Lu',
    },
    {
      name: 'Mardi',
      short: 'Ma',
    },
    {
      name: 'Mercredi',
      short: 'Me',
    },
    {
      name: 'Jeudi',
      short: 'Je',
    },
    {
      name: 'Vendredi',
      short: 'Ve',
    },
    {
      name: 'Samedi',
      short: 'Sa',
      isWeekend: true,
    },
  ],

  // just play around with this number between 0 and 6
  weekStartingIndex: 0,

  // return a { year: number, month: number, day: number } object
  getToday(gregorainTodayObject: any) {
    return gregorainTodayObject;
  },

  // return a native JavaScript date here
  toNativeDate(date: { year: number; month: number; day: number | undefined }) {
    return new Date(date.year, date.month - 1, date.day);
  },

  // return a number for date's month length
  getMonthLength(date: { year: number; month: number }) {
    return new Date(date.year, date.month, 0).getDate();
  },

  // return a transformed digit to your locale
  transformDigit(digit: any) {
    return digit;
  },

  // texts in the date picker
  nextMonth: 'Next Month',
  previousMonth: 'Previous Month',
  openMonthSelector: 'Open Month Selector',
  openYearSelector: 'Open Year Selector',
  closeMonthSelector: 'Close Month Selector',
  closeYearSelector: 'Close Year Selector',
  defaultPlaceholder: 'Select...',

  // for input range value
  from: 'from',
  to: 'to',

  // used for input value when multi dates are selected
  digitSeparator: ',',

  // if your provide -2 for example, year will be 2 digited
  yearLetterSkip: 0,

  // is your language rtl or ltr?
  isRtl: false,
};

// Residence Time function
export const ResidenceTime = (form: any, setForm: Function) => {
  let residenceTimeContent: any = [];
  let residenceTime: any = [
    form?.residenceTime1 || 0,
    form?.residenceTime2 || 0,
    form?.residenceTime3 || 0,
  ];

  residenceTime.forEach((element, i) => {
    residenceTimeContent.push(
      <InputNotation
        key={uuidv4()}
        className={'notation-input'}
        value={element}
        placeholder=''
        id={'residenceTime-input' + i}
        onValueChange={(e) => {
          setForm({ ...form, [`residenceTime${i + 1}`]: e.value });
        }}
      />,
    );
  });
  return residenceTimeContent;
};

// speedself cleaning function
export const SpeedSelfcleaning = (form: any, setForm: Function) => {
  let selfCleansingContent: any = [];
  let selfCleansing: any = [
    form?.selfCleansing1 || 0,
    form?.selfCleansing2 || 0,
    form?.selfCleansing3 || 0,
  ];
  selfCleansing.forEach((element, i) => {
    selfCleansingContent.push(
      <InputNotation
        key={uuidv4()}
        className={'notation-input'}
        value={element}
        placeholder=''
        id={'selfCleaning-input' + i}
        onValueChange={(e) => {
          setForm({ ...form, [`selfCleansing${i + 1}`]: e.value });
        }}
      />,
    );
  });
  return selfCleansingContent;
};

// Degradation function
export const PosteResidenceTime = (form: any, setForm: Function) => {
  let posteResidenceTimeContent: any = [];
  let PosteResidence: any = [
    form?.posteResidenceTime1 || 0,
    form?.posteResidenceTime2 || 0,
    form?.posteResidenceTime3 || 0,
  ];
  PosteResidence.forEach((element, i) => {
    posteResidenceTimeContent.push(
      <InputNotation
        key={uuidv4()}
        className={'notation-input'}
        value={element}
        placeholder=''
        id={'degradation-input' + i}
        onValueChange={(e) => {
          setForm({ ...form, [`posteResidenceTime${i + 1}`]: e.value });
        }}
      />,
    );
  });
  return posteResidenceTimeContent;
};

// Mesure function
export const BoonLister = (form: any, setForm: Function) => {
  let boonListerContent: any = [];
  let boonLister: any = [
    form?.boonLister1 || 0,
    form?.boonLister2 || 0,
    form?.boonLister3 || 0,
  ];
  boonLister.forEach((element, i) => {
    boonListerContent.push(
      <InputNotation
        key={uuidv4()}
        className={'notation-input'}
        value={element}
        placeholder=''
        id={'mesure-input' + i}
        onValueChange={(e) => {
          setForm({ ...form, [`boonLister${i + 1}`]: e.value });
        }}
      />,
    );
  });
  return boonListerContent;
};

export const reformatDate = (date: any) => {
  let finalMonth: string, finalDay: string, finalDate: string | null;
  if (date) {
    if (date.month < 10) {
      finalMonth = '0' + date.month;
    } else {
      finalMonth = date.month;
    }
    if (date.day < 10) {
      finalDay = '0' + date.day;
    } else {
      finalDay = date.day;
    }
    finalDate = date.year + '-' + finalMonth + '-' + finalDay;
  } else {
    finalDate = null;
  }
  return finalDate;
};

// Transform string Date to Date object
export const formatStringToDate = (date: string) => {
  const dateTime = moment(date).toDate();
  return {
    year: dateTime.getFullYear(),
    month: dateTime.getMonth() + 1,
    day: dateTime.getDate(),
  };
};

//function pour afficher les données de calcul
export const ShowDataCalcul: React.FC<ShowDataCalculProps> = ({
  form,
  showErrorMessage,
  setForm,
}) => {
  return (
    <Card key={0} automatedTestId='card-data' className='card-data'>
      <Word
        variant='p'
        textStyle='titleSmall'
        value='Données de calcul théorique'
        className='card-title'
        automatedTestId='card-title'
      />
      <Container className='dco-temp' automatedTestId='dco-temp'>
        <InputField
          title='DCO(mg/L)'
          className='dco-field'
          id='id-dco'
          placeholder='DCO mg/l'
          max={1000000}
          value={form?.dco}
          required
          onValueChange={(v: any) => {
            setForm((oldValues) => {
              return { ...oldValues, dco: v.value };
            });
          }}
        />
        <InputField
          title='Temp. Moyenne(°C)'
          required
          className='dco-field'
          id='id-temp'
          placeholder='Temp. C°'
          max={50}
          value={form?.averageTemp}
          onValueChange={(e: any) => {
            setForm((oldValues) => {
              return { ...oldValues, averageTemp: e.value };
            });
          }}
        />
      </Container>
      <Word
        variant='p'
        textStyle='normalReg'
        value="Présence d'un compresseur ?"
        className='compressor-title'
      />
      <RadioList
        className='compressor-radiolist'
        selected={form?.compressor ? 0 : 1}
        onChange={(v: any) => {
          setForm((oldValues) => {
            return {
              ...oldValues,
              compressor: !Boolean(v.id),
            };
          });
        }}
        values={TrueFalseInterface}
      />
      <Word
        variant='p'
        textStyle='normalReg'
        value="Présence d'une mesure de débit?"
        className='mesure-title'
      />
      <RadioList
        className='mesure-radiolist'
        selected={form?.flowMesure ? 0 : 1}
        onChange={(v: any) => {
          setForm((oldValues) => {
            return {
              ...oldValues,
              flowMesure: !Boolean(v.id),
            };
          });
        }}
        values={TrueFalseInterface}
      />
      <Container className='bachees' automatedTestId='bachees'>
        <InputField
          title='Vol. de bâchées (m³)'
          className='bachees-field'
          id='vol-bachees'
          placeholder='Volume L'
          value={form?.bachVolume}
          min={0}
          max={100000}
          onValueChange={(v: any) => {
            setForm((oldValues) => {
              return { ...oldValues, bachVolume: v.value };
            });
          }}
        />
        <InputField
          title='Nb. de bâchées par jour'
          className='bachees-field'
          id='nb-bachees'
          placeholder='Nombre'
          max={100000}
          min={0}
          value={form?.bachNumber}
          onValueChange={(v: any) => {
            setForm((oldValues) => {
              return { ...oldValues, bachNumber: v.value };
            });
          }}
        />
      </Container>
      {showErrorMessage.bach ? (
        <Word
          variant='p'
          textStyle='normalReg'
          value='Les deux champs doivent etre remplis'
          className='error'
          automatedTestId='error'
        />
      ) : null}
    </Card>
  );
};

//function pour afficher les données d'Observation
export const FieldObservation: React.FC<fieldObservationProps> = ({
  form,
  setForm,
  setLastMeasurementDate,
  setLastVisitDate,
  showErrorMessage,
  lastMeasurementDate,
  today,
  lastVisitDate,
}) => {
  return (
    <Card key={0} automatedTestId='card-data' className='card-data'>
      <Word
        variant='p'
        textStyle='titleSmall'
        value='Observations de terrain pour catégorisation'
        className='card-title'
        automatedTestId='card-title'
      />
      <Word
        variant='p'
        textStyle='normalReg'
        value="Présence de dispositif de traitement d'H2S?"
        className='treatment-device-title'
      />
      <RadioList
        className='treatment-device-radiolist'
        selected={form?.treatmentDevice ? 0 : 1}
        onChange={(v: any) => {
          setForm((oldValues) => {
            return {
              ...oldValues,
              treatmentDevice: !Boolean(v.id),
            };
          });
        }}
        values={TrueFalseInterface}
      />
      {/* mesure-radiolist */}
      <Word
        variant='p'
        textStyle='normalReg'
        value='Mesure qualitative (présence H2S)'
        className='mesure-title'
        automatedTestId='mesure-title'
      />
      <RadioList
        className='mesure-radiolist'
        selected={form?.qualiMeasure}
        onChange={(v: any) => {
          setForm((oldValues) => {
            return { ...oldValues, qualiMeasure: v.id };
          });
        }}
        values={MeasureInterface}
      />
      <Field
        label=''
        value={
          form?.qualiMeasureComment == null ? '' : form?.qualiMeasureComment
        }
        placeholder='Commentaire mesure'
        errorMessage=''
        onChange={(v) => {
          setForm((oldValues) => {
            return { ...oldValues, qualiMeasureComment: v };
          });
        }}
      />
      <ModernDatePicker
        className='datePick'
        inputClassName='date-picker-span'
        value={lastMeasurementDate}
        shouldHighlightWeekends
        maximumDate={today}
        formatInputText={() => {
          return inputTextDate(lastMeasurementDate);
        }}
        inputPlaceholder='Date de la dernière mesure'
        locale={dateFr}
        onChange={(v: any) => {
          setLastMeasurementDate(v);
        }}
      />
      {/* degradation-radiolist */}
      <Word
        variant='p'
        textStyle='normalReg'
        value='Dégradation génie civil'
        className='dégradation-title'
        automatedTestId='degradation-title'
      />
      <RadioList
        className='degradation-radiolist'
        selected={form?.civilEngDegrad}
        onChange={(v: any) => {
          setForm((oldValues) => {
            return { ...oldValues, civilEngDegrad: v.id };
          });
        }}
        values={DegradationInterface}
      />
      <Field
        label=''
        value={
          form?.civilEngDegradComment == null ? '' : form?.civilEngDegradComment
        }
        placeholder='Commentaire dégradation'
        errorMessage=''
        onChange={(v) => {
          setForm((oldValues) => {
            return { ...oldValues, civilEngDegradComment: v };
          });
        }}
      />
      <ModernDatePicker
        className='datePick2'
        inputClassName='date-picker-span'
        value={lastVisitDate}
        shouldHighlightWeekends
        maximumDate={today}
        formatInputText={() => {
          return inputTextDate(lastVisitDate);
        }}
        inputPlaceholder='Date de la dernière visite'
        locale={dateFr}
        onChange={(v: any) => {
          setLastVisitDate(v);
        }}
      />
      <Word
        variant='p'
        textStyle='normalReg'
        value='Facteur aggravant'
        className='facteur-title'
        automatedTestId='facteur-title'
      />
      <RadioList
        className='facteur-radiolist'
        selected={form?.aggravatingFactor}
        onChange={(v: any) => {
          setForm((oldValues) => {
            return { ...oldValues, aggravatingFactor: v.id };
          });
        }}
        values={AggravatingInterface}
      />
      <Field
        label=''
        value={form?.factorComment == null ? '' : form?.factorComment}
        placeholder='Commentaire facteur'
        errorMessage=''
        onChange={(v) => {
          setForm((oldValues) => {
            return { ...oldValues, factorComment: v };
          });
        }}
      />

      {showErrorMessage.bach ? (
        <Word
          variant='p'
          textStyle='normalReg'
          value='Les deux champs doivent etre remplis'
          className='error'
          automatedTestId='error'
        />
      ) : null}
    </Card>
  );
};

//function pour afficher l'inspection terrain
export const ShowInspection: React.FC<showInspectionProps> = ({
  form,
  setForm,
  setItvDate,
  itvDate,
  today,
}) => {
  return (
    <Card key={2} automatedTestId='card-inspection' className='card-inspection'>
      <Word
        variant='p'
        textStyle='titleSmall'
        value='Observations de terrain indicatives'
        className='card-title'
        automatedTestId='card-title'
      />
      <Container>
        <Word
          variant='p'
          textStyle='normalReg'
          value='Présence de dispositif de traitement d’odeur'
          className='presence-title'
        />
        <RadioList
          className='presence-radiolist'
          selected={form?.smellDevice ? 0 : 1}
          onChange={(v: any) => {
            setForm((oldValues) => {
              return { ...oldValues, smellDevice: !Boolean(v.id) };
            });
          }}
          values={TrueFalseInterface}
        />
        <Word
          variant='p'
          textStyle='normalReg'
          value="Bassin de collecte du PR sensible aux problématiques d'H2S"
          className='pr-sensible-title'
        />
        <RadioList
          className='pr-sensible-radiolist'
          selected={form?.smellSensitivity ? 0 : 1}
          onChange={(v: any) => {
            setForm((oldValues) => {
              return {
                ...oldValues,
                smellSensitivity: !Boolean(v.id),
              };
            });
          }}
          values={TrueFalseInterface}
        />
        <Word
          variant='p'
          textStyle='normalReg'
          value="Bassin de collecte du PR sensible aux problématiques d'odeur"
          className='pr-sensible-title'
        />
        <RadioList
          className='pr-sensible-radiolist'
          selected={form?.colPoolSmellSensitivity ? 0 : 1}
          onChange={(v: any) => {
            setForm((oldValues) => {
              return {
                ...oldValues,
                colPoolSmellSensitivity: !Boolean(v.id),
              };
            });
          }}
          values={TrueFalseInterface}
        />
        <Word
          variant='p'
          textStyle='normalReg'
          value="Visite d'installation"
          className='visite-title'
        />
        <RadioList
          className='visite-radiolist'
          selected={form?.siteVisit ? 0 : 1}
          onChange={(v: any) => {
            setForm((oldValues) => {
              return { ...oldValues, siteVisit: !Boolean(v.id) };
            });
          }}
          values={TrueFalseInterface}
        />
        {form?.siteVisit ? (
          <div className='visite-oui-switch'>
            <Switch
              name='Corrosion tampon'
              className='corrosion-switch'
              title='Corrosion tampon'
              checked={form?.tamponCorrosion}
              id='corrosion-switch'
              onChange={(v: any) => {
                setForm((oldValues) => {
                  return { ...oldValues, tamponCorrosion: v.value };
                });
              }}
            />
            <Switch
              name='Fissure'
              className='issure-switch'
              title='Fissure'
              checked={form?.crack!}
              id='fissure-switch'
              onChange={(v: any) => {
                setForm((oldValues) => {
                  return { ...oldValues, crack: v.value };
                });
              }}
            />
            <Switch
              name='Altération du béton'
              className='alteration-switch'
              title='Altération du béton'
              checked={form?.concreteAlteration}
              id='alteration-switch'
              onChange={(v: any) => {
                setForm((oldValues) => {
                  return { ...oldValues, concreteAlteration: v.value };
                });
              }}
            />
            <Switch
              name='Constat d’odeurs'
              className='odeur-switch'
              title='Constat d’odeurs'
              checked={form?.smellObservation}
              id='odeur-switch'
              onChange={(v: any) => {
                setForm((oldValues) => {
                  return { ...oldValues, smellObservation: v.value };
                });
              }}
            />
            <Field
              label=''
              value={
                form?.siteVisitComment == null ? '' : form?.siteVisitComment
              }
              errorMessage=''
              placeholder='Commentaire visite'
              onChange={(v) => {
                setForm((oldValues) => {
                  return { ...oldValues, siteVisitComment: v };
                });
              }}
            />
          </div>
        ) : null}
        <Word
          variant='p'
          textStyle='normalReg'
          value='ITV'
          className='visite-title'
        />
        <RadioList
          className='itv-radiolist'
          selected={form?.itv ? 0 : 1}
          onChange={(v: any) => {
            setForm((oldValues) => {
              return { ...oldValues, itv: !Boolean(v.id) };
            });
          }}
          values={TrueFalseInterface}
        />
        {form?.itv ? (
          <Container className='dateContainer'>
            <Container className='dateItv'>
              <ModernDatePicker
                className='datePick'
                inputClassName='date-picker-span'
                value={itvDate}
                shouldHighlightWeekends
                maximumDate={today}
                formatInputText={() => {
                  return inputTextDate(itvDate);
                }}
                inputPlaceholder='Date itv'
                locale={dateFr}
                onChange={(v: any) => {
                  setItvDate(v);
                }}
              />
            </Container>
            <Field
              label=''
              className='comment'
              value={form?.itvComment == null ? '' : form?.itvComment}
              placeholder='Commentaire itv'
              errorMessage=''
              onChange={(v) => {
                setForm((oldValues) => {
                  return { ...oldValues, itvComment: v };
                });
              }}
            />
          </Container>
        ) : null}
        <Word
          variant='p'
          textStyle='normalReg'
          value='Type de traitement en place'
          className='visite-title'
        />
        <RadioList
          className='visite-radiolist'
          selected={form?.treatmentType === 'Préventif' ? 0 : 1}
          onChange={(v: any) => {
            setForm((oldValues) => {
              return { ...oldValues, treatmentType: v.label };
            });
          }}
          values={TreatmentTypeInterface}
        />
      </Container>
    </Card>
  );
};
